import { useMemo, useState } from "react";
import getResults from "components/Shared/FilterEditor/getResults";
import { AppliedFilter } from "components/Shared/FilterEditor/utils";
import { useOptionalCombineFilters } from "utils/useCombineFilters";
import { OrderingPlatformFilter } from "__generated__/gql/graphql";
import FilterBarWithSearch, {
  FreestandingFilterBarContainer,
  FreestandingFilterWell,
} from "components/Shared/FilterEditor/FilterBar/FilterBarWithSearch";
import getFilterDefinitions from "./filterDefinitions";
import OrderingPlatformsDirectoryTable, {
  OrderingPlatformsDirectoryTableProps,
} from "./Table";

const DEFAULT_FILTERS: AppliedFilter[] = [];

export type OrderingPlatformDirectoryProps =
  OrderingPlatformsDirectoryTableProps & {
    defaultFilters?: AppliedFilter[];
    isAdmin?: boolean;
  };

export default function OrderingPlatformDirectory({
  defaultFilters = DEFAULT_FILTERS,
  filter: filterProp,
  isAdmin = false,
  ...rest
}: OrderingPlatformDirectoryProps) {
  const filterDefinitions = useMemo(
    () => getFilterDefinitions(isAdmin),
    [isAdmin],
  );

  const [filters, setFilters] = useState<AppliedFilter[]>(defaultFilters);

  const filterResults = useMemo(() => {
    if (!filters?.length) return;
    return getResults<OrderingPlatformFilter>(filterDefinitions, filters);
  }, [filters, filterDefinitions]);

  const tableFilters = useOptionalCombineFilters(filterProp, filterResults);

  return (
    <>
      <FilterBarWithSearch
        {...{ filterDefinitions, filters }}
        onFiltersChange={setFilters}
        FilterBarContainerComponent={FreestandingFilterBarContainer}
        FiltersContainerComponent={FreestandingFilterWell}
      />
      <OrderingPlatformsDirectoryTable
        filter={tableFilters}
        isAdmin={isAdmin}
        {...rest}
      />
    </>
  );
}
